import styled from 'styled-components'

export const Button = styled.button`
    color: ${ props => props.theme.colors.white };
    background-color: transparent;
    border: none;
    cursor: pointer;
    ${ props => props.s }
`
